import { createSliderFromItemList } from "./_createSliderFromItemList";

/**
 * Class to control the SOLR result slider element
 * @param {HTMLElement} list
 */
class SolrResultsSlider {
    constructor(list) {
        this.list = list;
        this._listSlider = this._createSlider();
    }

    // Create a slider element from the toujou list-item content element
    async _createSlider() {
        this._slider = await createSliderFromItemList(this.list, 'slider--solr-results');
    }
}

/**
 * Check for ".result-slider" elements and initialize them
 */
export function initSolrResultsSlider() {
    const resultSliderElements = document.querySelectorAll('.results-slider');

    if (!resultSliderElements) return;

    resultSliderElements.forEach((el) => {
        const list = el.querySelector('.item-list');
        if (!list) {
            console.error('TOUJOU: Could not initialize the "results-slider" element because the list element could not be found!');
        } else {
            new SolrResultsSlider(list);
        }
    })
}
